import moment from "moment"
import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"

import ListadoPedidosFilters from "./BBs/ListadoPedidosFilters/ListadoPedidosFilters"
import ListadoPedidosTable from "./BBs/ListadoPedidosTable/ListadoPedidosTable"

import Loader from "@components/ui/Loader/Loader"
import { Pedido } from "@models/pedidos"
import { Box } from "@mui/material"
import { EsfirusTablePropsPagination, HandleChangePaginationType } from "@services/hooks/useHandlerPaginationTable"
import { pedidosService } from "@services/pedidos"
import { useSelector } from "react-redux"
import { isJefeObra } from "@services/hooks/UserHook"

const ListadoPedidos = () => {
  const [filters, setFilters] = useState({
    empresa: "",
    dateFrom: moment().startOf("day").add(-3, "month"),
    dateTo: moment().startOf("day").add(1, "day").add(-1, "second"),
    empleado: "",
    status: "Confirmado&Abierto",
    excludeStatus: true,
    obra: "",
  })

  const [pedidos, setPedidos] = useState<Pedido[]>([])
  const [totalItems, setTotalItems] = useState<number>(0)
  const [availableFilters, setAvailableFilters] = useState<Array<any>>([]);
  const [loadingPedidos, setLoadingPedidos] = useState<boolean>(false)
  const [pagination, setPagination] = useState<EsfirusTablePropsPagination>({ page: 0, sizePage: 50 })
  const customFilters = useSelector((state) => (state as any).tableFilters['pedidos']?.sortTable);
  const userIsJefeObra = isJefeObra()

  useEffect(() => {
    let componentMounted = true;

    const parseKeyMap: Record<string, string> = {
      _id: 'unique_id',
      order_date: 'order_date',
      supplier_info: 'supplier_code',
      reference: 'reference',
      employee: 'user_character3',
      status_r_606: 'status_r_606'
    }

    const fetchPedidos = async () => {
      setLoadingPedidos(true);

      const sortBy = parseKeyMap[customFilters?.field?.keymap];
      const sortDirection = customFilters?.ascending ? 'asc' : 'desc';

      try {
        const resp = await pedidosService.getList({
          from: filters.dateFrom.unix(),
          to: filters.dateTo.unix(),
          company: filters.empresa,
          status: filters.status,
          empleado: (filters.obra && userIsJefeObra) ? "" : filters.empleado,
          obra: filters.obra,
          pagination,
          excludeStatus: filters.excludeStatus,
          ...(sortBy && sortDirection ? { sortBy, sortDirection } : {})
        })

        const {
          items: newItems = [],
          total_items: newTotalItems = 0,
          filters: newAvailableFilters = 0
        } = resp?.data?.data ?? {};

        if (componentMounted) {
          setPedidos(newItems);
          setTotalItems(newTotalItems);
          setAvailableFilters(newAvailableFilters);
        }
      } catch {
        setPedidos([])
        setTotalItems(0)
      } finally {
        if (componentMounted) setLoadingPedidos(false)
      }
    }

    fetchPedidos()

    return () => {
      componentMounted = false
    }
  }, [filters, pagination, userIsJefeObra])

  const handleChangePagination: HandleChangePaginationType = (newPaginationData) => {
    setPagination(newPaginationData)
  }

  return (
    <>
      <ListadoPedidosFilters filters={filters} setFilters={setFilters} items={pedidos} availableFilters={availableFilters} />
      <ListadoPedidosTable
        pedidos={pedidos}
        pagination={pagination}
        totalItems={totalItems}
        handleChangePagination={handleChangePagination}
        tableId="pedidos"
        loading={loadingPedidos}
      >
        <Box className="ml-20 mr-20 mt-40 mb-40">
          <Loader message="Cargando listado de pedidos" />
        </Box>
      </ListadoPedidosTable>

      {/* Para cargar el modal de view y edit pedidos */}
      <Outlet />
    </>
  );
}

export default ListadoPedidos;
